var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.hide)?_c('div',{staticClass:"toast",class:{'icon-toast':_vm.icon},style:({ opacity: _vm.opacity,visibility: _vm.opacity===0?'hidden':'visible' })},[(_vm.icon === 'success')?_c('div',{staticClass:"icon"}):_vm._e(),_c('div',{staticClass:"toast-inner"},[_vm._v(_vm._s(_vm.innerText))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }